import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { PingPongBall, PingPongPaddlePaths } from "./PingPongPaddleMark";

/**
 * Mono ping-pong bat for general UI (dashboard trays, empty states, etc.).
 */
export default function TableTennisRacketIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 64 64">
      <PingPongPaddlePaths
        mode="mono"
        transform="translate(2 0) rotate(-16 28 32)"
      />
      <PingPongBall cx="49" cy="14.5" r="5.4" mode="mono" />
    </SvgIcon>
  );
}
